import { sentryQabConfig } from './sentryConfig';

export const sentryConfigActivationLitterDataCapture = {
  ...sentryQabConfig,
  dsn: 'https://2802c11474188948b3d4ac41db9c93f1@o207017.ingest.sentry.io/4505979802812416',
};
